import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button} from "@material-ui/core";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import {Formik, Form} from "formik";
import Loading from "../../../../Loading";

import ValidationSchema from "./FormModel/validationSchema";
import CarFormModel from "./FormModel/formModel";
import FormInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

import VehiculoForm from './Forms/VehiculoForm';
import TitularForm from "./Forms/TitularForm";
import CoberturaForm from "./Forms/CoberturaForm";
import CoberturaFormMobile from './FormsMobile/CoberturaFormMobile'
import {useMediaQuery} from "react-responsive";
import car_white_icon from '../../../../../assets/images/white_car_icon.png'
import Axios from "axios";

import AffinityContext from "../../../../../context/AffinityContext";
import close_x from "../../../../../assets/images/close_x.png";
import {formatPhoneNumberIntl} from "react-phone-number-input";
import withMultipleContexts from "../../../../../context/utils/withMultipleContexts";
import loadAutomotorData from "../../../../../context/products/AutomotorContext/loadAutomotorData";
import AutomotorContextProvider from "../../../../../context/products/AutomotorContext/AutomotorContextProvider";
import handleJeepCase from "../../../../../context/products/AutomotorContext/services/handleJeepCase";

const steps = ["Titular", "Vehículo", "Cobertura"];
const {formId, formField} = CarFormModel;


function _renderStepContent(
    step,
    localidades,
    isMobile,
    vehicleDetails
) {
    switch (step) {
        case 0:
            return (<TitularForm
                formField={formField}
                localidadesData={localidades}
            />);
        case 1:
            return (<VehiculoForm
                formField={formField}
                vehicleDetails={vehicleDetails}
            />);
        case 2:
            return (isMobile ? <CoberturaFormMobile formField={formField}/> : <CoberturaForm formField={formField}/>);
        default:
            return <div>Not Found</div>;
    }
}

function CheckoutCustomerCotizar(props) {

    const {
        localidades,
        affinityId,
        affinityInterCode
    } = useContext(AffinityContext);

    let modifiedFormInitialValues = {
        ...FormInitialValues
    }

    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });

    const history = useHistory();
    const currentValidationSchema = ValidationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;

    const [valuesModal, setValuesModal] = useState([]);
    const [actionsModal, setActionsModal] = useState(null);
    const {confirmationModalOpen, setConfirmationModalOpen, isMobile, scrollIntoView} = props;
    const [localidadesMap, setLocalidadesMap] = useState(null)
    const [precotizacionResponse, setPrecotizacionResponse] = useState(null)
    const [cotizacionRequestResponse, setCotizacionRequestResponse] = useState(null);
    const vehicleDetails = useRef({
        detalle_marca: "",
        detalle_modelo: "",
        detalle_version: ""
    });

    useEffect(() => {
        let options = localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidadesMap(options);
    }, [localidades])

    async function _handlePrecotizar(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/precotizar/autos'

        const valuesPrecotizar = {
            "Nombre": values.name,
            "Apellido": values.lastName,
            "DNI": values.dni,
            "Email": values.email,
            "CodArea": formatPhoneNumberIntl(values.phone).split(' ')[1],
            "Telefono": `${formatPhoneNumberIntl(values.phone).split(' ')[2]}${formatPhoneNumberIntl(values.phone).split(' ')[3]}`,
            "Tipo": "VEHICULO",
            vehiculo: {
                "patente": values.vehiculo.patente,
                "version": values.vehiculo.version,
                "anio": values.vehiculo.anio,
            },
            "idAfinidad": affinityId
        }

        Axios.post(url, valuesPrecotizar).then((result) => {
            setPrecotizacionResponse(result['data'])
            actions.setSubmitting(false);
        }).catch((error) =>
            console.log(error));
    }

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/precotizar'

        values['idAfinidad'] = affinityId

        const valuesSend = {
            ...values,
            "id": precotizacionResponse.id,
            vehiculo: {
                ...values.vehiculo,
                ...vehicleDetails?.current,
                "marca": handleJeepCase(values.vehiculo.marca),
                "patente": values.vehiculo.patente.toUpperCase(),
                "valorGnc": values.vehiculo.valorGnc.toString(),
                "adtValue": values.vehiculo.adtValue.toString(),
            },
            "Tipo": "VEHICULO"
        }

        Axios.post(url, valuesSend).then((result) => {
            setConfirmationModalOpen(false)
            setCotizacionRequestResponse({
                status: result.status,
                details: result.data.status
            })
            history.push(`/a/${affinityInterCode}/${affinityId}/end`)
        }).catch((error) => {
            setCotizacionRequestResponse({
                status: 500,
                details: error
            })
        }).finally(() => {
            setLoading(false)
            actions.setSubmitting(false);
        })

    }

    function _handleSubmit(values, actions) {
        if (isLastStep) {
            actions.setTouched({});
            actions.setSubmitting(false);
            setValuesModal(values);
            setActionsModal(actions)
            setConfirmationModalOpen(true);
        } else if (activeStep === 1) {
            actions.setSubmitting(true);
            setActiveStep(activeStep + 1);
            _handlePrecotizar(values, actions)
        } else {
            scrollIntoView()
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    const handleClose = () => {
        setConfirmationModalOpen(false);
    }

    const displayModalContent = () => {
        if (loading) {
            return <Loading/>
        } else if (!cotizacionRequestResponse) {
            return (
                <>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                        <img
                            style={{
                                marginTop: "5px",
                                marginRight: "10px",
                            }}
                            onClick={handleClose}
                            src={close_x}
                            width={"12px"}
                            height={"12px"}
                        />
                    </div>
                    <div className={classes.modalColumn}>
                        <p className={classes.modalTitle} style={{marginBottom: "16px", marginTop: "16px"}}>
                            ¿Confirma su información de contacto?
                        </p>
                        <div>
                            <p className={classes.modalSubtitle}> Email </p>
                            <p className={classes.modalText2}> {valuesModal.email} </p>
                            <p className={classes.modalSubtitle}> Celular </p>
                            <p className={classes.modalText2}
                               style={{marginBottom: "24px"}}> {(valuesModal.phone).toString()} </p>
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingBottom: "16px"
                        }}>
                            <button className={classes.modalButtonModify} onClick={() => {
                                setActiveStep(0);
                                setConfirmationModalOpen(!confirmationModalOpen)
                            }}>
                                Modificar
                            </button>
                            <button className={classes.modalButtonConfirm} onClick={() => {
                                setLoading(true)
                                _submitForm(valuesModal, actionsModal);
                            }}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </>
            )
        } else if (cotizacionRequestResponse.status !== 200) {
            return (
                <div className={classes.modalColumn}>
                    <p className={classes.modalTitle} style={{marginBottom: "16px", marginTop: "16px"}}>
                        Hubo un problema al cargar su solicitud
                    </p>
                    <div className={classes.modalErrorTextContainer}>
                        <p className={classes.modalText2}>
                            Por favor, revise sus datos y reintente el proceso.
                        </p>
                        <p className={classes.modalErrorText}>
                            Si el problema persiste, pongase en contacto con su asesor utilizando el botón de Whatsapp
                            que se encuentra en la parte inferior derecha de la pantalla.
                        </p>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "16px",
                        paddingBottom: "16px"
                    }}>
                        <button className={classes.modalButtonConfirm} onClick={() => {
                            setCotizacionRequestResponse(null)
                            setActiveStep(0)
                            setConfirmationModalOpen(!confirmationModalOpen)
                        }}>
                            Reintentar
                        </button>
                    </div>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {localidadesMap ?
                <>
                    <div
                        className={classes.iconCircle}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "-50px",
                            height: "50px"
                        }}
                    >
                        <img src={car_white_icon} style={{width: "40px", height: "auto"}}/>
                    </div>

                    <div style={{margin: "24px 0"}}>
                        <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                    </div>

                    <Fragment>
                        <Formik
                            initialValues={modifiedFormInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting}) => (
                                <Form id={formId}>
                                    {_renderStepContent(
                                        activeStep,
                                        localidadesMap,
                                        isMobileDevice,
                                        vehicleDetails
                                    )}
                                    <div
                                        className="font-face-encode-sans-regular"
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            fontSize: "18px",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <div className={classes.buttons}>
                                            {activeStep !== 0 && (
                                                <Button
                                                    onClick={_handleBack}
                                                    className={classes.backButton}
                                                    disabled={isSubmitting}
                                                    variant="contained"
                                                >
                                                    Atras
                                                </Button>
                                            )}
                                            <div className={classes.buttons}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.buttonContained}
                                                >
                                                    {isLastStep ? "Solicitar cotización" : "Siguiente"}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Fragment>
                </>
                :
                <Loading/>}

            {confirmationModalOpen &&
            <div className={isMobile ? classes.modalMainMobile : classes.modalMainDesktop}>
                {displayModalContent()}
            </div>}
        </React.Fragment>
    );
}

export default withMultipleContexts(CheckoutCustomerCotizar, [
    {
        loadDataFunctions: [loadAutomotorData],
        ContextProvider: AutomotorContextProvider,
        dataKey: 'automotorData',
        storageKey: 'automotorData',
    }
])
